<div class="tab-list">
  <h2 class="ff-title-2xs ff-bold">
    {{ 'Dashboard.IspezioniTabStr' | translate }}
  </h2>
  <ds-button
    style="margin-left: auto"
    [attr.button-type]="'button'"
    [attr.reset-pair]="''"
    [attr.button-ui-variant]="'tertiary'"
    [attr.button-size]="'small'"
    [attr.button-label]="'Dashboard.VaiAlleIspezioniStr' | translate"
    [attr.button-icon]="'icon-arrow-right'"
    [attr.is-disabled]="false"
    [attr.button-aria-label]="'Dashboard.VaiAlleIspezioniStr' | translate"
    [attr.animation-play]="false"
    [attr.is-enable-activated]="false"
    [attr.has-aria-popup]="''"
    (onClickEvent)="goToIspezioni()"
    [attr.button-aria-controls]="''"
    [attr.button-aria-expanded]="''"></ds-button>
</div>

<div *ngIf="collaudiDownloadComplete">
  <div class="dashboard-table-wrapper" *ngIf="collaudiPresenti; else elseBlock">
    <ds-table
      class="dashboard-table"
      [tableConfig]="tableConfig"
      [attr.table-empty-title]="'emptyTableTitle' | translate"
      [attr.table-empty-description]="'emptyTableDescription' | translate"
      [attr.table-empty-image-url]="emptyImage"
      [attr.table-empty-image-alt]="'emptyTableAltImage' | translate"
      (onClickSecondRightAction)="onSecondRightIconClick($event)">
    </ds-table>
  </div>

  <ng-template #elseBlock>
    <app-no-element></app-no-element>
  </ng-template>
</div>

<ds-spinner
  *ngIf="!collaudiDownloadComplete"
  [attr.spinner-ui-variant]="'spinner'"
  [attr.spinner-aria-label]="'Caricamento' | translate"></ds-spinner>
